/**
 * Write all your custom api constants here
 */
export class BaseApiConstants {

}
